import { PageAttr } from "../../../../shared/domain/entities/fetch-entities";
// @ts-expect-error - No declaration is required - TODO: - Stop using when the project is migrated.
import { REACT_APP_BACKEND_COMMON_URL } from "@env";
import { useConcatPages } from "../../../../shared/infrastructure";
import { useFetch } from "../../../../public/auth/infrastructure/store/fetch-context";
import { RevenueCodeT, UseGetRevenueCodeFilters } from "../../domain";
import {
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  useInfiniteQuery,
} from "@tanstack/react-query";

const revenueCodeKeys = {
  all: ["revenue-codes"] as const,
  revenueCodes: () => [...revenueCodeKeys.all, "revenue-codes-list"] as const,
  revenueCodesList: (filters: UseGetRevenueCodeFilters) =>
    [...revenueCodeKeys.revenueCodes(), filters] as const,
};

const REVENUE_CODES_ENDPOINT = "mcleod-revenue-codes";

const useInfiniteGetRevenueCodes = (
  filters: UseGetRevenueCodeFilters,
  config: UseInfiniteQueryOptions<PageAttr<RevenueCodeT>> = {}
): UseInfiniteQueryResult<PageAttr<RevenueCodeT>> & {
  allPages: PageAttr<RevenueCodeT>["data"];
} => {
  const fetch = useFetch();

  const response = useInfiniteQuery<PageAttr<RevenueCodeT>>(
    revenueCodeKeys.revenueCodesList(filters),
    async ({ pageParam: page = 1 }: { pageParam?: number }) => {
      const response = await fetch.get<PageAttr<RevenueCodeT>>(
        REVENUE_CODES_ENDPOINT,
        {
          baseURL: REACT_APP_BACKEND_COMMON_URL as string,
          params: {
            page,
            limit: 10,
            ...filters,
          },
        }
      );

      return response.data;
    },
    {
      ...config,
      getNextPageParam: (lastPage, allPages) =>
        lastPage.data.length > 0 ? allPages.length + 1 : undefined,
    }
  );

  const allPages = useConcatPages(response.data?.pages ?? []);

  return {
    ...response,
    allPages,
  };
};

export { revenueCodeKeys, useInfiniteGetRevenueCodes };
